export default __webpack_public_path__ + "static/2contenido_pandagroup-dc0a023044a4d411f19fb78001fce84b.png";